import { render, staticRenderFns } from "./ReportesSerieActivaPantalla.vue?vue&type=template&id=ddf22778&"
import script from "./ReportesSerieActivaPantalla.vue?vue&type=script&lang=ts&"
export * from "./ReportesSerieActivaPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports